  (function () {
    var MAX_WAIT_MS = 3000;
    var SNIZE_MOBILE_INPUT_ID = 'snize-mobile-search-input';

    var NATIVE_INPUT_SELECTORS = [
      '.search-input.snize-input-style',
      'predictive-search-component input[type="search"]',
      'predictive-search-input input[type="search"]',
      '.search-modal input[name="q"]',
      'dialog[open] input[type="search"]',
    ];

    function isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function isVisible(el) {
      if (!el) return false;
      if (el.offsetParent !== null) return true;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }

    function findNativeSearchInput() {
      for (var i = 0; i < NATIVE_INPUT_SELECTORS.length; i++) {
        var el = document.querySelector(NATIVE_INPUT_SELECTORS[i]);
        if (el && isVisible(el)) return el;
      }
      return null;
    }

    function findSnizeMobileInput() {
      var el = document.getElementById(SNIZE_MOBILE_INPUT_ID);
      return el && isVisible(el) ? el : null;
    }

    function fireUserLikeActivation(el) {
      if (!el) return;
      var rect = el.getBoundingClientRect();
      var x = rect.left + rect.width / 2;
      var y = rect.top + rect.height / 2;

      function dispatch(type, EventCtor, init) {
        try {
          el.dispatchEvent(
            new EventCtor(
              type,
              Object.assign({ bubbles: true, cancelable: true, composed: true }, init || {})
            )
          );
        } catch (e) {
          try {
            var evt = document.createEvent('Event');
            evt.initEvent(type, true, true);
            el.dispatchEvent(evt);
          } catch (_) {}
        }
      }

      dispatch('pointerover', PointerEvent, { clientX: x, clientY: y, pointerType: 'touch' });
      dispatch('pointerdown', PointerEvent, { clientX: x, clientY: y, pointerType: 'touch' });
      dispatch('mousedown', MouseEvent, { clientX: x, clientY: y });
      try { el.focus({ preventScroll: true }); } catch (_) { try { el.focus(); } catch (__) {} }
      dispatch('focusin', FocusEvent);
      dispatch('focus', FocusEvent);
      dispatch('pointerup', PointerEvent, { clientX: x, clientY: y, pointerType: 'touch' });
      dispatch('mouseup', MouseEvent, { clientX: x, clientY: y });
      dispatch('click', MouseEvent, { clientX: x, clientY: y });
    }

    /**
     * Run `predicate()` repeatedly via MutationObserver + safety timeout.
     * Calls `onFound(result)` when predicate returns truthy. Calls `onTimeout()` after MAX_WAIT_MS.
     */
    function waitFor(predicate, onFound, onTimeout) {
      var existing = predicate();
      if (existing) {
        onFound(existing);
        return;
      }
      var startedAt = Date.now();
      var done = false;

      var observer = new MutationObserver(function () {
        if (done) return;
        var found = predicate();
        if (found) {
          done = true;
          observer.disconnect();
          onFound(found);
        } else if (Date.now() - startedAt > MAX_WAIT_MS) {
          done = true;
          observer.disconnect();
          if (typeof onTimeout === 'function') onTimeout();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        if (!done) {
          done = true;
          observer.disconnect();
          if (typeof onTimeout === 'function') onTimeout();
        }
      }, MAX_WAIT_MS);
    }

    /**
     * Full mobile flow:
     *  1. Wait for native input (modal must open first)
     *  2. Activate native input → forces Searchanise to inject its mobile input
     *  3. Wait for Searchanise's mobile input
     *  4. Focus it so the keyboard pops up on the right field
     */
    function runMobileSearchHandoff() {
      waitFor(
        findNativeSearchInput,
        function (nativeInput) {
          // Step 2: activate native input → Searchanise lazy-loads mobile UI
          fireUserLikeActivation(nativeInput);
          console.log('[Search] Activated native input, waiting for Searchanise mobile input…');

          // Step 3 + 4: wait for snize-mobile-search-input, then focus it
          waitFor(
            findSnizeMobileInput,
            function (snizeInput) {
              fireUserLikeActivation(snizeInput);
              console.log('[Search] Focused Searchanise mobile input — ready to type');
            },
            function () {
              console.warn(
                '[Search] #' + SNIZE_MOBILE_INPUT_ID +
                  ' did not appear after activating native input.'
              );
            }
          );
        },
        function () {
          console.warn('[Search] Native search input did not appear within ' + MAX_WAIT_MS + 'ms');
        }
      );
    }
    function closeNativeSearchModal() {
      var dialogComp = document.querySelector('dialog-component#search-modal');
      if (dialogComp && typeof dialogComp.closeDialog === 'function') {
        try {
          dialogComp.closeDialog();
          console.log('[Search] Native search modal closed');
          return true;
        } catch (e) {
          console.warn('[Search] closeDialog threw:', e);
        }
      }
      var nativeDialog = document.querySelector('dialog.search-modal__content[open]');
      if (nativeDialog && typeof nativeDialog.close === 'function') {
        try {
          nativeDialog.close();
          console.log('[Search] Native <dialog> closed via .close()');
          return true;
        } catch (e) {
          console.warn('[Search] dialog.close threw:', e);
        }
      }
      return false;
    }




    document.addEventListener('DOMContentLoaded', function () {
      var searchButtons = document.querySelectorAll(
        'search-button .button-unstyled.header-actions__action, ' +
          'button.header-actions__action[aria-label="Search"], ' +
          'button.header-actions__action[aria-haspopup="dialog"][aria-label*="Search" i]'
      );

      if (!searchButtons.length) {
        console.warn('[Search] No search button found.');
        return;
      }
      console.log(searchButtons);

      searchButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Desktop already works — only intervene on mobile.
          if (!isMobileViewport()) return;
          // DO NOT preventDefault — we need the native modal to open so its input renders.
          requestAnimationFrame(runMobileSearchHandoff);
        });
      });

      document.addEventListener(
        'click',
        function (e) {
          var backBtn =
            e.target && e.target.closest
              ? e.target.closest(
                  '.snize-close-button-arrow, [aria-label="Back"].snize-close-button-arrow'
                )
              : null;
          if (!backBtn) return;
          // Let Searchanise handle its own close first, then close the native modal.
          setTimeout(closeNativeSearchModal, 0);
        },
        true
      );


      console.log(
        '[Search] Mobile Searchanise handoff bound to ' + searchButtons.length + ' button(s)'
      );
    });
  })();
